import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const CreateBulkTransferWrapper = styled.div`
  .MuiTabs-root {
    display: none;
  }

  .accordion-header {
    margin-top: 16px;
  }

  .header-back {
    margin-top: 16px;
    height: 16px;
    svg {
      width: 18px;
      height: 16px;
      margin-left: 16px;
    }
  }
  .form-container {
    padding: 0px 0px 16px 16px;
  }
  .form-field {
    padding-right: 16px;
  }
`;

export const InformationWrapper = styled.div`
  .confirm-message {
    color: ${COLORS.cirrus_black10};
    line-height: 22px;
  }
`;
